import React from 'react';
import { connect } from 'react-redux';
import { decorateWith, withName } from 'helpers/decorator';
import { DefineVariables } from 'providers/ContextVariables';
import { injectIntl } from 'react-intl';
import { withSagas } from 'decorators/Sagas/Sagas';
import { deepExtract } from 'helpers/deep';
import { isEmpty } from 'helpers/verify';
import { formatPrice, generateOfferContextVariables } from 'helpers/promotions';
import { selectPagePromotion } from 'redux/modules/page';
import { selectActivePromotion } from 'redux/saga/helpers/promotions';
import { cmsRemoveBanner, selectShouldShowCmsBanner } from './CmsBanner.reducer';
import { CmsBanner } from './CmsBanner';
import { loadCmsBannerSaga, watchPagePromotionForBanner } from './CmsBanner.saga';

export const mapStateToProps = state => {
  const promoAlias = selectPagePromotion(state);
  const promotion = selectActivePromotion(state, promoAlias);
  const offer = (promotion.offers || []).find(Boolean) || {};
  const shouldShowBanner = selectShouldShowCmsBanner(state);
  return {
    currency: deepExtract('msa.currency_code', offer),
    offer,
    shouldShowBanner,
  };
};

const mapDispatchToProps = {
  onBannerClose: cmsRemoveBanner,
};

export const CmsBannerWithContextVariables = ({ currency, intl, offer, ...rest }) =>
  !isEmpty(offer) && (
    <DefineVariables
      variables={generateOfferContextVariables({
        offer,
        initialPrice: formatPrice({
          intl,
          currency,
          price: offer.price,
        }),
        recurringPrice: formatPrice({
          intl,
          currency,
          price: offer.recurring_plan && offer.recurring_plan.price,
        }),
      })}>
      <CmsBanner {...rest} />
    </DefineVariables>
  );

export const CmsBannerContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withName('CmsBanner'),
  withSagas({
    watch: watchPagePromotionForBanner,
    load: loadCmsBannerSaga,
  })
)(CmsBannerWithContextVariables);
